import { render, staticRenderFns } from "./veggiesbonanza.vue?vue&type=template&id=1243887d"
import script from "./veggiesbonanza.vue?vue&type=script&lang=js"
export * from "./veggiesbonanza.vue?vue&type=script&lang=js"
import style0 from "./veggiesbonanza.vue?vue&type=style&index=0&id=1243887d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports